import { render } from "./BFormRadio.vue?vue&type=template&id=e165ee7c&ts=true"
import script from "./BFormRadio.vue?vue&type=script&lang=ts"
export * from "./BFormRadio.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__